import { companyObj, VariablesObj } from "../../../types/Company"
import { ActivityT, ClientAgreementT, CogsLineItemT, ColoradoClientAgreementT, ConsumerAdvisementT, CrewProspectsLineItemT, DocumentsT, DocumentT, EstimateLineItemT, EstimateT, ExpenseLineItemT, FinancialT, InvoiceLineItemT, InvoiceT, JobT, LineItemsValuationT, LineItemValuationT, LocationT, PaymentLineItemT, PaymentsT, RevenueLineItemT, ValuationT } from "../../../types/Job"
import { DamageT, InfractionObj, InfractionT, InvoiceWorkerT, JobWorkerObj, JobWorkerT } from "../../../types/JobWorker"
import { BillingContactObj, BillingContactT, ClientObj, ClientT } from "../../../types/Users"
import { copyObject, randomId } from "../../../utils"


export const initCrewProspects: CrewProspectsLineItemT = {
  id: null,
  status: null,
  jobId: null,
  workerId: null,
  worker: null,
  date: null
}


export const DamageObj: DamageT = {
  id: -1,
  amount: 0,
  cause: '',
  damageDate: '',
  damageType: '',
  itemDamaged: ''
}


export const EstimateLineItemObj: EstimateLineItemT = {
  id: randomId(),
  item: '',
  lineItemDate: '',
  rate: 0,
  total: 0,
  units: 1
}

export const InvoiceLineItemObj: InvoiceLineItemT = {
  id: randomId(),
  item: '',
  lineItemDate: '',
  rate: 0,
  total: 0,
  units: 1
}
export const EstimateObj: EstimateT = {
  active: true,
  title: 'Estimate',
  name: 'estimate',
  variables: [
    {
      key: 'dirty',
      type: "boolean",
      value: false
    },
    {
      key: 'lineItems',
      type: "array",
      value: [
        {
          item: 'hourlyRateTwo',
          lineItemDate: '',
          rate: VariablesObj.hourlyRateTwo.value,
          total: VariablesObj.hourlyRateTwo.value,
          units: 1
        }
      ]
    }
  ],
  defaultAgreement: {
    type: 'acknowledgement',
    clause: 'I acknowledge that I have been given a copy of this estimate to keep for my records.',
    content: null,
    timestamp: null,
    ip: null,
    userAgent: null,
  },
  agreement: []
}



export const InvoiceObj: InvoiceT = {
  active: true,
  title: 'Invoice',
  name: 'invoice',
  variables: [
    {
      key: 'dirty',
      type: "boolean",
      value: false
    },
    {
      key: 'lineItems',
      type: "array",
      value: [
        {
          item: 'hourlyRateTwo',
          lineItemDate: '',
          rate: VariablesObj.hourlyRateTwo.value,
          total: VariablesObj.hourlyRateTwo.value,
          units: 1
        }
      ]
    }
  ],
}

export const ConsumerAdvisementObj: ConsumerAdvisementT = {
  active: true,
  title: 'consumer Advisement',
  name: 'consumerAdvisement',
  variables: [
    // {
    //     key: "estimate",
    //     type: "array",
    //     value: [],
    // }
  ],
  defaultAgreement: {
    type: 'acknowledgement',
    clause: 'I acknowledge that I have been given a copy of this consumer advisement to keep for my records.',
    content: null,
    timestamp: null,
    ip: null,
    userAgent: null,

  },
  agreement: []

}




export const ValuationObj: ValuationT = {
  coverage: null,
  deductible: null,
  name: '',
  premium: null
}

export const lineItemsValuationObj: LineItemsValuationT = {
  optionA1: {
    accept: null,
    reject: null,
  },
  optionA2: {
    accept: null,
    reject: null,
  },
  optionB: {
    accept: null,
    reject: null,
  },
}

export const initLineItemValuation: LineItemValuationT = {
  accept: null,
  reject: null
}

export const ColoradoClientAgreementObj: ColoradoClientAgreementT = {
  active: true,
  state: 'Colorado',
  title: 'Client Agreement',
  name: 'coloradoClientAgreement',
  variables: [
    {
      key: "cargoInsurance",
      type: "boolean",
      value: false,
    },
    {
      key: "optionsValuation",
      type: "any",
      value: lineItemsValuationObj,
    },
    {
      key: "valuation",
      type: "object",
      value: {
        coverage: null,
        deductible: null,
        name: null,
        premium: null
      },
    },
    {
      key: "valueOfShipment",
      type: "number",
      value: false,
    },
    {
      key: "estimate",
      type: "array",
      value: [],
    }
  ]
  ,
  defaultAgreement: {
    type: 'agreement',
    clause: 'I Agreed.',
    content: null,
    timestamp: null,
    ip: null,
    userAgent: null,

  },
  agreement: []
}


export const DocumentObj: DocumentT = {
  active: false,
  name: null,
  title: null,
  variables: [],
}


export const DocumentsObj: DocumentsT = {
  estimate: copyObject(EstimateObj),
  invoice: copyObject(InvoiceObj)
}
export const CogsLineItemObj: CogsLineItemT = {
  id: randomId(),
  date: '',
  item: '',
  rate: 0,
  total: 0,
  units: 1,
  isDirty: false,
  isAutoFill: false,

}


export const ExpenseLineItemObj: ExpenseLineItemT = {
  id: randomId(),
  date: '',
  item: '',
  rate: 0,
  total: 0,
  units: 1,
  isDirty: false,
}



export const RevenueLineItemObj: RevenueLineItemT = {
  id: randomId(),
  item: '',
  date: '',
  rate: 1,
  units: 1,
  total: 1,
  isDirty: false,
}
export const FinancialObj: FinancialT = {
  cogs: {
    isDirty: false,
    lineItems: []
  },
  expenses: {
    isDirty: false,
    lineItems: [ExpenseLineItemObj]
  },
  revenue: {
    isDirty: false,
    lineItems: []
  },
}

export const PaymentLineItemObj: PaymentLineItemT = {
  id: null,
  amount: 0,
  date: null,
  method: 'cash',
  paymentType: null,
}

export const PaymentsObj: PaymentsT = {
  dirty: false,
  lineItems: [PaymentLineItemObj]
}



export const ActivityObj: ActivityT = {
  id: randomId(),
  activityDate: '',
  activityType: '',
  endTime: '',
  index: null,
  startTime: ''
}

export const LocationObj: LocationT = {
  activities: [ActivityObj],
  address: '',
  address2: '',
  addressCountry: '',
  addressState: '',
  elevator: null,
  latitude: null,
  locationSize: null,
  locationType: '',
  longCarry: null,
  longitude: null,
  numRooms: null,
  numStairFlights: null,
  stairsflights: null
}

export const JobObj : JobT = {
  id: null,
  addedBy: null,
  cargo: [],
  billingContact: copyObject(BillingContactObj),
  client: copyObject(ClientObj),
  crew: [JobWorkerObj, JobWorkerObj],
  documents: copyObject(DocumentsObj),
  docs: [],
  financial: copyObject(FinancialObj),
  isBillingContact: true,
  jobSource: 'craigslist',
  jobStatus: 'inquiring',
  jobType: 'moving_labor',
  locations: [copyObject(LocationObj)],
  notes: '',
  payments: PaymentsObj,
  companyInfo: companyObj,
  contactPerson: [],
  timeOfScheduling: null,
  closedIn: {
    communicationId: 0,
    time: 0,
  },
  fkDispute: null
}
